// extracted by mini-css-extract-plugin
export default {"root":"App_root__40Hjl","container":"App_container__Rt8T2","body":"App_body__PuluK"};